Global.controller = new ScrollMagic.Controller();

class InterSectionScroll {
    scene: any;
    section: any;
    elements: Array<string> = ['[data-anim-card]', '[data-anim-content-show]', '[data-anim-stagger]', '[data-anim-show-contact]', '[data-anim-graph]', '[data-anim-fade]', '[data-anim-map]', '[data-anim-arrow-scroll]'];
    sections: Array<Object> = [];

    constructor() {
        this.generateSections(this.elements);
        this.scrollHandler();
    }

    public generateSections(elements: Array<string>) {
        elements.forEach((element) => {
            let tmpElements = document.querySelectorAll(element);



            Array.prototype.forEach.call(tmpElements,(tmpElement:any) => {
                let triggerHook = parseFloat(tmpElement.getAttribute('data-anim-trigger-hook'));
                let animScope = tmpElement.getAttribute(this.getDataName(element));
                if(!animScope) {
                    return;
                }
                this.sections.push({
                    selector: tmpElement,
                    triggerHook: isNaN(triggerHook) ? 0.6 : triggerHook,
                    animation: {
                        enter: Animations[animScope].enter,
                        leave: Animations[animScope].leave
                    }
                })
            });
        });
    }

    public getDataName(name: any){
        return name.slice(1,-1);
    }

    scrollHandler() {
        Array.prototype.forEach.call(this.sections, (section: any) => {

            return new ScrollMagic.Scene({
                triggerElement: section.selector,
                triggerHook: section.triggerHook,
                reverse:false
            })
                //.addIndicators()
                .setTween(section.animation.enter(section.selector))
                .addTo(Global.controller);
        });
    }
}
